import { type RpmPicks, type Team } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { ConfidenceBar } from '@public/components/Db/Profile/Rpm/ConfidenceBar';

import styles from './RpmPick.module.scss';

export const RpmPick = ({ pick }: { pick: RpmPicks }) => {
  const { organization = {} as Team } = pick;

  return (
    <div className={styles.block}>
      <Avatar
        altText={`${organization.name} avatar`}
        domain={organization.asset?.domain}
        height={20}
        source={organization.asset?.source}
        teamAvatar
        width={20}
      />
      <ConfidenceBar
        className={styles.confidenceBar}
        confidence={pick.confidence}
      />
    </div>
  );
};
